var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_2723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4735 12.1766C14.4624 12.1766 16.8853 9.75363 16.8853 6.76479C16.8853 3.77596 14.4624 1.35303 11.4735 1.35303C8.4847 1.35303 6.06177 3.77596 6.06177 6.76479C6.06177 9.75363 8.4847 12.1766 11.4735 12.1766Z",
    stroke: "black",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00293 23C2.00293 18.5167 6.24306 14.8823 11.4735 14.8823C16.704 14.8823 20.9441 18.5167 20.9441 23",
    stroke: "black",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_2723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6471,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3200aa2140e90ab1e52826331bca7ada.svg";
export { ForwardRef as ReactComponent };